<template>
  <div
    class='is-fullheight flex flex-column site-page-card'
    :class="{'selected-site-page': isSelected}">
    <div class="top-part border-bottom is-size-6 title-font mainColor--text flex align-center">
      <span class="d-flex align-center flex-gap-10">
        <i v-if="isSelected" class="material-icons checked-box" @click="$store.getters.isDemoUser ? null : $emit('unselect', site.id)">check_box</i>
        <i v-else class="material-icons checked-box" @click="$store.getters.isDemoUser ? null : $emit('select', site.id)">check_box_outline_blank</i>
        <v-tooltip top color="transparent">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              class="material-icons pin-icon" :class="{ 'pinned': site.isPinned }"
              @click="() => $store.getters.isDemoUser ? null : $emit('pin', { siteId: site.id, isPinned: !site.isPinned })">push_pin</span>
          </template>
          <div class="white-bg-tooltip small-tooltip">
            {{
              site.isPinned ? 'Click to unpin' : 'Pin this Project to the top of your dashboard to find it easily.'
            }}
          </div>
        </v-tooltip>
        <v-tooltip top color="transparent">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on"
              class="material-icons guard-icon" :class="{ 'guarded': hasGuardPage(site) }">
              verified_user
            </span>
          </template>
          <div class="white-bg-tooltip small-tooltip">
            {{
              hasGuardPage(site) ? 'This Project is monitored by POP Watchdog.' : 'This Project is not monitored by POP Watchdog.'
            }}
          </div>
        </v-tooltip>
      </span>
      <div class="flex-grow-1"></div>
      <div>
        <v-btn icon :id="`dot-menu-for-${site.id}`">
          <span class="material-icons-outlined mainColor--text">more_horiz</span>
        </v-btn>
        <v-menu
          v-if="!isDemo"
          :activator="`#dot-menu-for-${site.id}`"
          bottom offset-y>
          <v-list>
            <v-list-item link @click="$store.getters.isDemoUser ? null : $emit('open-settings', site)">
              <v-list-item-title
                class="mainColor--text">
                Project setting
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!(site.isExample && $store.getters.isNoPlanUser)" link @click="$store.getters.isDemoUser ? null : $emit('delete', site.id)">
              <v-list-item-title
                class="mainColor--text">
                Delete
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <div class="main-part">
      <div class="flex-grow-1">
        <div class="mt-5">
          <img src="/static/site-icon.png" />
        </div>
        <div class="mt-3 tooltip is-tooltip-top"
          style="max-width: 100%;" :data-tooltip="site.name">
          <div class="project-name truncate-ellipse-one-line">
            {{ site.name }}
          </div>
        </div>
        <div class="mt-1 mainColor--text font-weight-regular">
          Created on {{ createdAt }}
        </div>
        <div v-if="site.isExample" class="mt-2">
          <span class="example-project-badge">Sample project, read-only</span>
        </div>
      </div>
      <footer>
        <v-btn
          rounded
          color="profileAnchorColor"
          :to="`/sites/${site.id}/tools`"
          class="view-project-page-button whiteColor--text text-none">
          <span>
            Open
          </span>
        </v-btn>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    site: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isDemo: {
      type: Boolean,
      default: false,
    },
    createdAt: {
      type: String,
      default: '',
    },
  },
  methods: {
    hasGuardPage (site) {
      for (const page of site.pages) {
        if (page.isGoogleGuardEnabled) {
          return true
        }
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
/* Signup redesign: the example project of a no-plan account */
.example-project-badge {
  display: inline-block;
  background: #eef3ff;
  border: 1px solid #c9d8ff;
  color: #014751;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
}
</style>
